import { createSlice } from "@reduxjs/toolkit";
import {
  postMedicalCommonAppRepo,
  getMedicalIdpStatusRepo,
  getMedicalDegreeRepo,
  postMedicalDegreeRepo,
  getMedicalExamRepo,
  postMedicalExamRepo,
  getMedicalSpecializationRepo,
  postMedicalSpecializationRepo,
  getMedicalCoachingRepo,
  postMedicalCoachingRepo,
  getMedicalCoachingListRepo,
  postMedicalCoachingListRepo,
  getMedicalPrefereLocationRepo,
  postMedicalPrefereLocationRepo,
  getMedicalPrefereCollegeRepo,
  postMedicalPrefereCollegeRepo,
  getMedicalOtherSpecializationRepo,
  postMedicalOtherSpecializationRepo,
  getMedicalTopCollegeRepo,
  postMedicalTopCollegeRepo,
  getMedicalProductRepo,
  postMedicalProductRepo,
  postMedicalLeadCreateRepo,
  getMedicalFormStatusRepo,
  postMedicalFormSubmitRepo
} from "../../repositories/medcal";

const medicalFormlSlice = createSlice({
  name: "medicalFormreducer",
  initialState: {
    postMedicalCommonAppSuccess: null,
    postMedicalCommonAppError: null,

    medicalIdpStatusLoading: null,
    medicalIdpStatusSuccess: null,
    medicalIdpStatusError: null,

    medicalFormStatusLoading: null,
    medicalFormStatusSuccess: null,
    medicalFormStatusError: null,

    medicalDegreeLoading: null,
    medicalDegreeSuccess: null,
    medicalDegreeError: null,
    postMedicalDegreeSuccess: null,
    postMedicalDegreeError: null,

    medicalExamLoading: null,
    medicalExamSuccess: null,
    medicalExamError: null,
    postMedicalExamSuccess: null,
    postMedicalExamError: null,

    medicalSpecializationLoading: null,
    medicalSpecializationSuccess: null,
    medicalSpecializationError: null,
    postMedicalSpecializationSuccess: null,
    postMedicalSpecializationError: null,

    medicalCoachingLoading: null,
    medicalCoachingSuccess: null,
    medicalCoachingError: null,
    postMedicalCoachingSuccess: null,
    postMedicalCoachingError: null,

    medicalCoachingListLoading: null,
    medicalCoachingListSuccess: null,
    medicalCoachingListError: null,
    postMedicalCoachingListSuccess: null,
    postMedicalCoachingListError: null,

    medicalPreferLocationLoading: null,
    medicalPreferLocationSuccess: null,
    medicalPreferLocationError: null,
    postMedicalPreferLocationSuccess: null,
    postMedicalPreferLocationError: null,

    medicalPreferCollegeLoading: null,
    medicalPreferCollegeSuccess: null,
    medicalPreferCollegeError: null,
    postMedicalPreferCollegeSuccess: null,
    postMedicalPreferCollegeError: null,

    medicalProductsLoading: null,
    medicalProductsSuccess: null,
    medicalProductsError: null,
    postMedicalProductsSuccess: null,
    postMedicalProductsError: null,

    medicalProductsOneToOneLoading: null,
    medicalProductsOneToOneSuccess: null,
    medicalProductsOneToOneError: null,
    postMedicalProductsOneToOneSuccess: null,
    postMedicalProductsOneToOneError: null,

    medicalProductsEnrollmentLoading: null,
    medicalProductsEnrollmentSuccess: null,
    medicalProductsEnrollmentError: null,
    postMedicalProductsEnrollmentSuccess: null,
    postMedicalProductsEnrollmentError: null,

    medicalOtherSpecializationLoading: null,
    medicalOtherSpecializationSuccess: null,
    medicalOtherSpecializationError: null,
    postMedicalOtherSpecializationSuccess: null,
    postMedicalOtherSpecializationError: null,

    medicalTopCollegesLoading: null,
    medicalTopCollegesSuccess: null,
    medicalTopCollegesError: null,
    postMedicalTopCollegesSuccess: null,
    postMedicalTopCollegesError: null,

    postMedicalLeadCreateSuccess: null,
    postMedicalLeadCreateError: null,

    //FormSubmit
    postMedicalFormSubmitSuccess: null,
    postMedicalFormSubmitError: null,
    
  },

  reducers: {
    //Common App
    postMedicalCommonAppSuccess(state, action) {
      return {
        ...state,
        postMedicalCommonAppSuccess: action.payload,
      };
    },
    postMedicalCommonAppFailure(state, action) {
      return {
        ...state,
        postMedicalCommonAppError: action.payload,
      };
    },

    //IDP status
    getMedicalIdpStatusLoading(state, action) {
      return {
        ...state,
        medicalIdpStatusLoading: true,
      };
    },
    getMedicalIdpStatusSuccess(state, action) {
      return {
        ...state,
        medicalIdpStatusLoading: false,
        medicalIdpStatusSuccess: action.payload,
      };
    },
    getMedicalIdpStatusFailure(state, action) {
      return {
        ...state,
        medicalIdpStatusLoading: false,
        medicalIdpStatusError: action.payload,
      };
    },

    getMedicalDegreeLoading(state, action) {
      return {
        ...state,
        medicalDegreeLoading: true,
      };
    },
    getMedicalDegreeSuccess(state, action) {
      return {
        ...state,
        medicalDegreeLoading: false,
        medicalDegreeSuccess: action.payload,
      };
    },
    getMedicalDegreeFailure(state, action) {
      return {
        ...state,
        medicalDegreeLoading: false,
        medicalDegreeError: action.payload,
      };
    },
    postMedicalDegreeSuccess(state, action) {
      return {
        ...state,
        postMedicalDegreeSuccess: action.payload,
      };
    },
    postMedicalDegreeFailure(state, action) {
      return {
        ...state,
        postMedicalDegreeError: action.payload,
      };
    },

    getMedicalExamLoading(state, action) {
      return {
        ...state,
        medicalExamLoading: true,
      };
    },
    getMedicalExamSuccess(state, action) {
      return {
        ...state,
        medicalExamLoading: false,
        medicalExamSuccess: action.payload,
      };
    },
    getMedicalExamFailure(state, action) {
      return {
        ...state,
        medicalExamLoading: false,
        medicalExamError: action.payload,
      };
    },
    postMedicalExamSuccess(state, action) {
      return {
        ...state,
        postMedicalExamSuccess: action.payload,
      };
    },
    postMedicalExamFailure(state, action) {
      return {
        ...state,
        postMedicalExamError: action.payload,
      };
    },
    //specialization
    getMedicalSpecializationLoading(state, action) {
      return {
        ...state,
        medicalSpecializationLoading: true,
      };
    },
    getMedicalSpecializationSuccess(state, action) {
      return {
        ...state,
        medicalSpecializationLoading: false,
        medicalSpecializationSuccess: action.payload,
      };
    },
    getMedicalSpecializationFailure(state, action) {
      return {
        ...state,
        medicalSpecializationLoading: false,
        medicalSpecializationError: action.payload,
      };
    },
    postMedicalSpecializationSuccess(state, action) {
      return {
        ...state,
        postMedicalSpecializationSuccess: action.payload,
      };
    },
    postMedicalSpecializationFailure(state, action) {
      return {
        ...state,
        postMedicalSpecializationError: action.payload,
      };
    },
    //coaching
    getMedicalCoachingLoading(state, action) {
      return {
        ...state,
        medicalCoachingLoading: true,
      };
    },
    getMedicalCoachingSuccess(state, action) {
      return {
        ...state,
        medicalCoachingLoading: false,
        medicalCoachingSuccess: action.payload,
      };
    },
    getMedicalCoachingFailure(state, action) {
      return {
        ...state,
        medicalCoachingLoading: false,
        medicalCoachingError: action.payload,
      };
    },
    postMedicalCoachingSuccess(state, action) {
      return {
        ...state,
        postMedicalCoachingSuccess: action.payload,
      };
    },
    postMedicalCoachingFailure(state, action) {
      return {
        ...state,
        postMedicalCoachingError: action.payload,
      };
    },
    //CoachingList
    getMedicalCoachingLoading(state, action) {
      return {
        ...state,
        medicalCoachingLoading: true,
      };
    },
    getMedicalCoachingListSuccess(state, action) {
      return {
        ...state,
        medicalCoachingListLoading: false,
        medicalCoachingListSuccess: action.payload,
      };
    },
    getMedicalCoachingListFailure(state, action) {
      return {
        ...state,
        medicalCoachingListLoading: false,
        medicalCoachingListError: action.payload,
      };
    },
    postMedicalCoachingListSuccess(state, action) {
      return {
        ...state,
        postMedicalCoachingListSuccess: action.payload,
      };
    },
    postMedicalCoachingListFailure(state, action) {
      return {
        ...state,
        postMedicalCoachingListError: action.payload,
      };
    },


    //Prefer Location
    getMedicalPreferLocationLoading(state, action) {
      return {
        ...state,
        medicalPreferLocationLoading: true,
      };
    },
    getMedicalPreferLocationSuccess(state, action) {
      return {
        ...state,
        medicalPreferLocationLoading: false,
        medicalPreferLocationSuccess: action.payload,
      };
    },
    getMedicalPreferLocationFailure(state, action) {
      return {
        ...state,
        medicalPreferLocationLoading: false,
        medicalPreferLocationError: action.payload,
      };
    },
    postMedicalPreferLocationSuccess(state, action) {
      return {
        ...state,
        postMedicalPreferLocationSuccess: action.payload,
      };
    },
    postMedicalPreferLocationFailure(state, action) {
      return {
        ...state,
        postMedicalPreferLocationError: action.payload,
      };
    },
    //Prefer College
    getMedicalPreferCollegeLoading(state, action) {
      return {
        ...state,
        medicalPreferCollegeLoading: true,
      };
    },
    getMedicalPreferCollegeSuccess(state, action) {
      return {
        ...state,
        medicalPreferCollegeLoading: false,
        medicalPreferCollegeSuccess: action.payload,
      };
    },
    getMedicalPreferCollegeFailure(state, action) {
      return {
        ...state,
        medicalPreferCollegeLoading: false,
        medicalPreferCollegeError: action.payload,
      };
    },
    postMedicalPreferCollegeSuccess(state, action) {
      return {
        ...state,
        postMedicalPreferCollegeSuccess: action.payload,
      };
    },
    postMedicalPreferCollegeFailure(state, action) {
      return {
        ...state,
        postMedicalPreferCollegeError: action.payload,
      };
    },

    //careers products free counselling
    getMedicalProductsLoading(state, action) {
      return {
        ...state,
        medicalProductsLoading: true,
      };
    },
    getMedicalProductsSuccess(state, action) {
      return {
        ...state,
        medicalProductsLoading: false,
        medicalProductsSuccess: action.payload,
      };
    },
    getMedicalProductsFailure(state, action) {
      return {
        ...state,
        medicalProductsLoading: false,
        medicalProductsError: action.payload,
      };
    },
    postMedicalProductsSuccess(state, action) {
      return {
        ...state,
        postMedicalProductsSuccess: action.payload,
      };
    },
    postMedicalProductsFailure(state, action) {
      return {
        ...state,
        postMedicalProductsError: action.payload,
      };
    },

    //careers products One to One Counseling
    getMedicalProductsOneToOneLoading(state, action) {
      return {
        ...state,
        medicalProductsOneToOneLoading: true,
      };
    },
    getMedicalProductsOneToOneSuccess(state, action) {
      return {
        ...state,
        medicalProductsOneToOneLoading: false,
        medicalProductsOneToOneSuccess: action.payload,
      };
    },
    getMedicalProductsOneToOneFailure(state, action) {
      return {
        ...state,
        medicalProductsOneToOneLoading: false,
        medicalProductsOneToOneError: action.payload,
      };
    },
    postMedicalProductsOneToOneSuccess(state, action) {
      return {
        ...state,
        postMedicalProductsOneToOneSuccess: action.payload,
      };
    },
    postMedicalProductsOneToOneFailure(state, action) {
      return {
        ...state,
        postMedicalProductsOneToOneError: action.payload,
      };
    },

    //careers products Enrollment
    getMedicalProductsEnrollmentLoading(state, action) {
      return {
        ...state,
        medicalProductsEnrollmentLoading: true,
      };
    },
    getMedicalProductsEnrollmentSuccess(state, action) {
      return {
        ...state,
        medicalProductsEnrollmentLoading: false,
        medicalProductsEnrollmentSuccess: action.payload,
      };
    },
    getMedicalProductsEnrollmentFailure(state, action) {
      return {
        ...state,
        medicalProductsEnrollmentLoading: false,
        medicalProductsEnrollmentError: action.payload,
      };
    },
    postMedicalProductsEnrollmentSuccess(state, action) {
      return {
        ...state,
        postMedicalProductsEnrollmentSuccess: action.payload,
      };
    },
    postMedicalProductsEnrollmentFailure(state, action) {
      return {
        ...state,
        postMedicalProductsEnrollmentError: action.payload,
      };
    },

    //Other Specializations
    getMedicalOtherSpecializationLoading(state, action) {
      return {
        ...state,
        medicalOtherSpecializationLoading: true,
      };
    },
    getMedicalOtherSpecializationSuccess(state, action) {
      return {
        ...state,
        medicalOtherSpecializationLoading: false,
        medicalOtherSpecializationSuccess: action.payload,
      };
    },
    getMedicalOtherSpecializationFailure(state, action) {
      return {
        ...state,
        medicalOtherSpecializationLoading: false,
        medicalOtherSpecializationError: action.payload,
      };
    },
    postMedicalOtherSpecializationSuccess(state, action) {
      return {
        ...state,
        postMedicalOtherSpecializationSuccess: action.payload,
      };
    },
    postMedicalOtherSpecializationFailure(state, action) {
      return {
        ...state,
        postMedicalOtherSpecializationError: action.payload,
      };
    },
    //TopColleges
    getMedicalTopCollegesLoading(state, action) {
      return {
        ...state,
        medicalTopCollegesLoading: true,
      };
    },
    getMedicalTopCollegesSuccess(state, action) {
      return {
        ...state,
        medicalTopCollegesLoading: false,
        medicalTopCollegesSuccess: action.payload,
      };
    },
    getMedicalTopCollegesFailure(state, action) {
      return {
        ...state,
        medicalTopCollegesLoading: false,
        medicalTopCollegesError: action.payload,
      };
    },
    postMedicalTopCollegesSuccess(state, action) {
      return {
        ...state,
        postMedicalTopCollegesSuccess: action.payload,
      };
    },
    postMedicalTopCollegesFailure(state, action) {
      return {
        ...state,
        postMedicalTopCollegesError: action.payload,
      };
    },
    //FormStatus
    getMedicalFormStatusLoading(state, action) {
      return {
        ...state,
        medicalFormStatusLoading: true,
      };
    },
    getMedicalFormStatusSuccess(state, action) {
      return {
        ...state,
        medicalFormStatusLoading: false,
        medicalFormStatusSuccess: action.payload,
      };
    },
    getMedicalFormStatusFailure(state, action) {
      return {
        ...state,
        medicalFormStatusLoading: false,
        medicalFormStatusError: action.payload,
      };
    },

    //LeadCreate
    postMedicalLeadCreateSuccess(state, action) {
      return {
        ...state,
        postMedicalLeadCreateSuccess: action.payload,
      };
    },
    postMedicalLeadCreateFailure(state, action) {
      return {
        ...state,
        postMedicalLeadCreateError: action.payload,
      };
    },

    //FormSubmit
    postMedicalFormSubmitSuccess(state, action) {
      return {
        ...state,
        postMedicalFormSubmitSuccess: action.payload,
      };
    },
    postMedicalFormSubmitFailure(state, action) {
      return {
        ...state,
        postMedicalFormSubmitError: action.payload,
      };
    },
  },
});

export const {
  postMedicalCommonAppSuccess,
  postMedicalCommonAppFailure,

  getMedicalIdpStatusLoading,
  getMedicalIdpStatusSuccess,
  getMedicalIdpStatusFailure,

  getMedicalFormStatusLoading,
  getMedicalFormStatusSuccess,
  getMedicalFormStatusFailure,

  getMedicalDegreeLoading,
  getMedicalDegreeSuccess,
  getMedicalDegreeFailure,
  postMedicalDegreeSuccess,
  postMedicalDegreeFailure,

  getMedicalExamLoading,
  getMedicalExamSuccess,
  getMedicalExamFailure,
  postMedicalExamSuccess,
  postMedicalExamFailure,

  getMedicalSpecializationLoading,
  getMedicalSpecializationSuccess,
  getMedicalSpecializationFailure,
  postMedicalSpecializationSuccess,
  postMedicalSpecializationFailure,

  getMedicalCoachingLoading,
  getMedicalCoachingSuccess,
  getMedicalCoachingFailure,
  postMedicalCoachingSuccess,
  postMedicalCoachingFailure,

  //MedicalCoachingList
  getMedicalCoachingListLoading,
  getMedicalCoachingListSuccess,
  getMedicalCoachingListFailure,
  postMedicalCoachingListSuccess,
  postMedicalCoachingListFailure,

  getMedicalPreferLocationLoading,
  getMedicalPreferLocationSuccess,
  getMedicalPreferLocationFailure,
  postMedicalPreferLocationSuccess,
  postMedicalPreferLocationFailure,

  getMedicalPreferCollegeLoading,
  getMedicalPreferCollegeSuccess,
  getMedicalPreferCollegeFailure,
  postMedicalPreferCollegeSuccess,
  postMedicalPreferCollegeFailure,

  getMedicalProductsLoading,
  getMedicalProductsSuccess,
  getMedicalProductsFailure,
  postMedicalProductsSuccess,
  postMedicalProductsFailure,

  getMedicalProductsOneToOneLoading,
  getMedicalProductsOneToOneSuccess,
  getMedicalProductsOneToOneFailure,
  postMedicalProductsOneToOneSuccess,
  postMedicalProductsOneToOneFailure,

  getMedicalProductsEnrollmentLoading,
  getMedicalProductsEnrollmentSuccess,
  getMedicalProductsEnrollmentFailure,
  postMedicalProductsEnrollmentSuccess,
  postMedicalProductsEnrollmentFailure,

  getMedicalOtherSpecializationLoading,
  getMedicalOtherSpecializationSuccess,
  getMedicalOtherSpecializationFailure,
  postMedicalOtherSpecializationSuccess,
  postMedicalOtherSpecializationFailure,

  getMedicalTopCollegesLoading,
  getMedicalTopCollegesSuccess,
  getMedicalTopCollegesFailure,
  postMedicalTopCollegesSuccess,
  postMedicalTopCollegesFailure,

  postMedicalLeadCreateSuccess,
  postMedicalLeadCreateFailure,

  postMedicalFormSubmitSuccess,
  postMedicalFormSubmitFailure

} = medicalFormlSlice.actions;

//Common App
export const postMedicalCommonApp = (data) => {
  return async (dispatch) => {
    await postMedicalCommonAppRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postMedicalCommonAppSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postMedicalCommonAppFailure(error.message));
        }
      });
  };
};

//getMedicalIdpStatus
export const getMedicalIdpStatus = (params) => {
  return async (dispatch) => {
    await getMedicalIdpStatusRepo(params)
      .then((response) => {
        if (response.status === 200) {
          dispatch(getMedicalIdpStatusSuccess(response?.data));
        } else {
          dispatch(getMedicalIdpStatusFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getMedicalIdpStatusFailure(error.message));
        }
      });
  };
};

//getMedicalFormStatus
export const getMedicalFormStatus = (params) => {
  return async (dispatch) => {
    await getMedicalFormStatusRepo(params)
      .then((response) => {
        if (response.status === 200) {
          dispatch(getMedicalFormStatusSuccess(response?.data));
        } else {
          dispatch(getMedicalFormStatusFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getMedicalFormStatusFailure(error.message));
        }
      });
  };
};

export const getMedicalDegree = (params) => {
  return async (dispatch) => {
    await getMedicalDegreeRepo(params)
      .then((response) => {
        if (response.status === 200) {
          dispatch(getMedicalDegreeSuccess(response?.data));
        } else {
          dispatch(getMedicalDegreeFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getMedicalDegreeFailure(error.message));
        }
      });
  };
};

export const postMedicalDegree = (data) => {
  return async (dispatch) => {
    await postMedicalDegreeRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postMedicalDegreeSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postMedicalDegreeFailure(error.message));
        }
      });
  };
};

export const getMedicalExam = (params, id) => {
  return async (dispatch) => {
    await getMedicalExamRepo(params, id)
      .then((response) => {
        if (response.status === 200) {
          dispatch(getMedicalExamSuccess(response?.data));
        } else {
          dispatch(getMedicalExamFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getMedicalExamFailure(error.message));
        }
      });
  };
};

export const postMedicalExam = (data) => {
  return async (dispatch) => {
    await postMedicalExamRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postMedicalExamSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postMedicalExamFailure(error.message));
        }
      });
  };
};

//Specialization
export const getMedicalSpecialization = (params, id) => {
  return async (dispatch) => {
    await getMedicalSpecializationRepo(params, id)
      .then((response) => {
        if (response.status === 200) {
          dispatch(getMedicalSpecializationSuccess(response?.data));
        } else {
          dispatch(getMedicalSpecializationFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getMedicalSpecializationFailure(error.message));
        }
      });
  };
};

export const postMedicalSpecialization = (data) => {
  return async (dispatch) => {
    await postMedicalSpecializationRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postMedicalSpecializationSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postMedicalSpecializationFailure(error.message));
        }
      });
  };
};

//Coaching
export const getMedicalCoaching = (params, id) => {
  return async (dispatch) => {
    await getMedicalCoachingRepo(params, id)
      .then((response) => {
        if (response.status === 200) {
          dispatch(getMedicalCoachingSuccess(response?.data));
        } else {
          dispatch(getMedicalCoachingFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getMedicalCoachingFailure(error.message));
        }
      });
  };
};

export const postMedicalCoaching = (data) => {
  return async (dispatch) => {
    await postMedicalCoachingRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postMedicalCoachingSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postMedicalCoachingFailure(error.message));
        }
      });
  };
};

//Coaching List
export const getMedicalCoachingList = (params, id) => {
  return async (dispatch) => {
    await getMedicalCoachingListRepo(params, id)
      .then((response) => {
        if (response.status === 200) {
          dispatch(getMedicalCoachingListSuccess(response?.data));
        } else {
          dispatch(getMedicalCoachingListFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getMedicalCoachingListFailure(error.message));
        }
      });
  };
};

export const postMedicalCoachingList = (data) => {
  return async (dispatch) => {
    await postMedicalCoachingListRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postMedicalCoachingListSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postMedicalCoachingListFailure(error.message));
        }
      });
  };
};

//Prefer Location
export const getMedicalPreferLocation = (params, id) => {
  return async (dispatch) => {
    await getMedicalPrefereLocationRepo(params, id)
      .then((response) => {
        if (response.status === 200) {
          dispatch(getMedicalPreferLocationSuccess(response?.data));
        } else {
          dispatch(getMedicalPreferLocationFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getMedicalPreferLocationFailure(error.message));
        }
      });
  };
};

export const postMedicalPreferLocation = (data) => {
  return async (dispatch) => {
    await postMedicalPrefereLocationRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postMedicalPreferLocationSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postMedicalPreferLocationFailure(error.message));
        }
      });
  };
};

//Prefer College
export const getMedicalPreferCollege = (params, id) => {
  return async (dispatch) => {
    await getMedicalPrefereCollegeRepo(params, id)
      .then((response) => {
        if (response.status === 200) {
          dispatch(getMedicalPreferCollegeSuccess(response?.data));
        } else {
          dispatch(getMedicalPreferLocationFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getMedicalPreferCollegeFailure(error.message));
        }
      });
  };
};

export const postMedicalPreferCollege = (data) => {
  return async (dispatch) => {
    await postMedicalPrefereCollegeRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postMedicalPreferCollegeSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postMedicalPreferCollegeFailure(error.message));
        }
      });
  };
};

//Products free counselling
export const getMedicalProducts = (params, id) => {
  return async (dispatch) => {
    await getMedicalProductRepo(params, id)
      .then((response) => {
        if (response.status === 200) {
          dispatch(getMedicalProductsSuccess(response?.data));
        } else {
          dispatch(getMedicalProductsFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getMedicalProductsFailure(error.message));
        }
      });
  };
};

export const postMedicalProducts = (data) => {
  return async (dispatch) => {
    await postMedicalProductRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postMedicalProductsSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postMedicalProductsFailure(error.message));
        }
      });
  };
};

//Products One to One Counseling
export const getMedicalProductsOneToOne = (params, id) => {
  return async (dispatch) => {
    await getMedicalProductRepo(params, id)
      .then((response) => {
        if (response.status === 200) {
          dispatch(getMedicalProductsOneToOneSuccess(response?.data));
        } else {
          dispatch(getMedicalProductsOneToOneFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getMedicalProductsOneToOneFailure(error.message));
        }
      });
  };
};

export const postMedicalProductsOneToOne = (data) => {
  return async (dispatch) => {
    await postMedicalProductRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postMedicalProductsOneToOneSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postMedicalProductsOneToOneFailure(error.message));
        }
      });
  };
};

//Products interested in enrolling for Careers360
export const getMedicalProductsEnrollment = (params, id) => {
  return async (dispatch) => {
    await getMedicalProductRepo(params, id)
      .then((response) => {
        if (response.status === 200) {
          dispatch(getMedicalProductsEnrollmentSuccess(response?.data));
        } else {
          dispatch(getMedicalProductsEnrollmentFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getMedicalProductsEnrollmentFailure(error.message));
        }
      });
  };
};

export const postMedicalProductsEnrollment = (data) => {
  return async (dispatch) => {
    await postMedicalProductRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postMedicalProductsEnrollmentSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postMedicalProductsEnrollmentFailure(error.message));
        }
      });
  };
};

//Specialization
export const getMedicalOtherSpecialization = (params, id) => {
  return async (dispatch) => {
    await getMedicalOtherSpecializationRepo(params, id)
      .then((response) => {
        if (response.status === 200) {
          dispatch(getMedicalOtherSpecializationSuccess(response?.data));
        } else {
          dispatch(getMedicalPreferLocationFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getMedicalOtherSpecializationFailure(error.message));
        }
      });
  };
};

export const postMedicalOtherSpecialization = (data) => {
  return async (dispatch) => {
    await postMedicalOtherSpecializationRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postMedicalOtherSpecializationSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postMedicalOtherSpecializationFailure(error.message));
        }
      });
  };
};

//top CollegePrefer
export const getMedicalTopColleges = (params, id) => {
  return async (dispatch) => {
    await getMedicalTopCollegeRepo(params, id)
      .then((response) => {
        if (response.status === 200) {
          dispatch(getMedicalTopCollegesSuccess(response?.data));
        } else {
          dispatch(getMedicalPreferLocationFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getMedicalTopCollegesFailure(error.message));
        }
      });
  };
};

export const postMedicalTopColleges = (data) => {
  return async (dispatch) => {
    await postMedicalTopCollegeRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postMedicalTopCollegesSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postMedicalTopCollegesFailure(error.message));
        }
      });
  };
};

//postMedicalLeadCreate
export const postMedicalLeadCreate = (data) => {
  return async (dispatch) => {
    await postMedicalLeadCreateRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postMedicalLeadCreateSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postMedicalLeadCreateFailure(error.message));
        }
      });
  };
};

//FormSubmit
export const postMedicalFormSubmit = (data) => {
  return async (dispatch) => {
    await postMedicalFormSubmitRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postMedicalFormSubmitSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postMedicalFormSubmitFailure(error.message));
        }
      });
  };
};

export default medicalFormlSlice.reducer;
